module.exports = __webpack_public_path__ + "static/media/space-station-moon-alt.6811e273.svg";